import React from 'react';

import S from './Calendar.module.css';

const weekDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
];

export const CalendarImg = () => {
  const date = new Date();
  const dd = weekDays[date.getDay()];
  return (
    <div className={S.root}>
      <div className={S.day}>{dd}</div>
      <div className={S.dayNum}>{date.getDate()}</div>
    </div>
  );
};
